/**
 * @generated SignedSource<<c9af6b7017b6452e5dea074ece2388e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuAvailability_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly offers: {
          readonly edges: ReadonlyArray<{
            readonly __typename: string;
          }>;
          readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityDelivery_ProductSkuOfferConnection" | "ProductSkuAvailabilityPickup_ProductSkuOfferConnection" | "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection">;
        } | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuAvailability_Product";
};
export type ProductSkuAvailability_Product$key = {
  readonly " $data"?: ProductSkuAvailability_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailability_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuAvailability_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    }
                  ],
                  "concreteType": "ProductSkuOfferConnection",
                  "kind": "LinkedField",
                  "name": "offers",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuOfferEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductSkuAvailabilityDelivery_ProductSkuOfferConnection"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductSkuAvailabilityPickup_ProductSkuOfferConnection"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "f903cf5005ebc694a9337020246e09ad";

export default node;
